import { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { DiscordButton } from './components';
import { MiscellaneousApi } from 'services';

const Messaging = () => {
  const [discordLink, setDiscordLink] = useState(null);

  useEffect(() => {
    MiscellaneousApi.getDiscordInvitationLink().then((data) => {
      setDiscordLink(data.instant_invite);
    });
  }, []);

  return (
    <Grid container justifyContent="center" alignItems="center" spacing={3}>
      <Grid container item xs={12} justifyContent="center">
        <Typography variant="h1">Messagerie</Typography>
      </Grid>

      <Grid
        container
        item
        direction="column"
        xs={12}
        style={{
          marginTop: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          alignContent: 'center',
          height: '70vh',
        }}
      >
        <Typography style={{ marginBottom: 10 }} color="primary" variant="h2">
          Vous avez des questions ?
        </Typography>
        <Box style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
          <Typography color="textSecondary" variant="h4" style={{ marginRight: '8px' }}>
            Rejoignez-nous sur notre discord !
          </Typography>
        </Box>
        <DiscordButton link={discordLink} />
      </Grid>
    </Grid>
  );
};

export default Messaging;
